import { Box, Grid, Collapse, Typography, Link, useTheme, useMediaQuery } from "@mui/material";
import Card from "../../common/Card";
import Button from "../../common/Button";
import Table, { Row } from "../../common/CustomTable";
import { useLocation } from "react-router-dom";
import { useEffect, useMemo, useState } from "react";
import { useAppDispatch } from "../../../redux/slice/redux-hooks";
import { useForm } from "react-hook-form";
import { formatPaymentMethod, hideElement, priceFormatter, rederDynamicStatusColor, sortNames } from "../../../utils/Utility";
import { createListSort } from "../../../utils/listSort";
import { AgencyInfo, fetchAppConfigList, fetchManufacturersList, setSingleAlertObj, SingleAlertInfo, updateElementInCommonSlice, useCommonReducer, fetchAgenciesList, showHideLoadingDialog } from "../../../redux/slice/commonSlice";
import { CAN_ACCESS_APPLICATION, EXPORTABLE_ITEMS, PAYMENT_ACTIONS, PAYMENT_STATUS, USER_ROLE_ENTITY_NAMES, USER_ROLES } from "../../../constants/applicationConstants";
import { getSearchCriteriaFromSessionStorage, saveSelectionForPage, setSearchCriteriaToSessionStorage } from "../../../utils/StorageUtils";
import { PracticeInfo } from "../../../redux/slice/practice/practiceRegistrationSlice";
import { updateElementInUserSlice } from "../../../redux/slice/userSlice";
import CustomMultipleDropDown from "../../common/CustomMultipleDropDown";
import { selectIsValueFoundInToken, selectTokenValues, useAuthSlice } from "../../../redux/slice/authSlice";
import CustomTextField from "../../common/CustomTextField";
import { useNavigation } from "../../../hooks/useNavigation";
import { useFilterPanelFocus } from "../../../hooks/useFilterPanelFocus";
import { getPracticeListByUserRolePaymentSlice, PaymentInfo, resetPaymentList, SearchPaymentRequest, searchPayments, usePaymentSlice, voidPayment } from "../../../redux/slice/payment/paymentSlice";
import { fetchProductsForProductsSearch, useProductListReducer, ProductInfo } from "../../../redux/slice/product/productListSlice"; //CS-2103
import dayjs from "dayjs";
import { ListAltOutlined, PlaylistRemoveOutlined, SearchOutlined, Notifications, NotificationsOutlined, ExitToApp, CloudDownload, DownloadOutlined, BoltOutlined } from "@mui/icons-material";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import CustomIconButton from "../../common/CustomIconButton";
import { SUCCESS_CODE } from "../../../service/ServiceConstants";
import { tokens } from "../../../theme";
import OptionsPopup from "../../common/OptionsPopup";
import { CodeTable, fetchAllCodeTablesValues, getCodeTableValuesByTableName, useCodetablesSlice } from "../../../redux/slice/codetableSlice";
import CustomDateRange from "../../common/CustomDateRange";
import CustomDropdownField from "../../common/CustomDropdownFiled";
import { fetchActiveAgencyExecutives, usePracticeApproveSlice } from "../../../redux/slice/practice/practiceApproveSlice";
import CustomAmountRange from "../../common/CustomAmountRange";
import { DateObject } from "react-multi-date-picker";
import { acknowledgeNotification, fetchAlertEntityNumbers, fetchNotificationsByRefEntities, useCreateNotificationSlice } from "../../../redux/slice/inbox/createNotificationSlice";
import StatusInfoPopup from "../../common/StatusInfoPopup";
import KeyboardArrowDown from "@mui/icons-material/KeyboardArrowDown";
import StyledMenu from "../../common/StyledMenu";
import ExportToExcel from "../../common/ExportToExcel";
import { useListPageStyles } from "../../common/useListPageStyles";

interface Column {
    id: string;
    label: string;
    minWidth?: number;
    align?: "right" | "center" | "left";
    format?: (value: number) => string;
}

type Option = {
    value: string,
    label: string
};

const ITEMS_PER_PAGE = 20;

const paymentListSort = createListSort(
  ["invoiceNumber", "transactionId", "invoiceAmount", "paymentAmount", "invoiceDate", "manufacturerName", "practiceName", "orderNumber", "paymentDate", "agencyName", "accountRepNames", "paymentType", "paymentStatus"] as const,
  {
    invoiceNumber: "invoiceNumber",
    transactionId: "transactionId",
    invoiceAmount: "invoiceAmount",
    paymentAmount: "paymentAmount",
    invoiceDate: "invoiceDate",
    manufacturerName: "manufacturerName",
    practiceName: "practiceName",
    orderNumber: "orderNumber",
    paymentDate: "paymentDate",
    agencyName: "agencyName",
    accountRepsNames: "accountRepNames",
    paymentType: "paymentType",
    customPaymentStatus: "paymentStatus",
  }
);

export const formatMethodLabel = (code: string) => {
    let s = code.trim().replace(/_/g, " ");
    return s.charAt(0).toUpperCase() + s.slice(1);
};
const PaymentList = () => {

    const location = useLocation();
    const { navigate } = useNavigation();
    const dispatch = useAppDispatch();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);
    const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
    const {
        cardSx,
        filterPanelSx,
        primaryActionBtnSx,
        outlineBtnSx,
        exportMenuPaperSx,
        exportMenuItemBtnSx,
        tableSx,
    } = useListPageStyles();
    const paymentRecordBtnSx = {
        ...primaryActionBtnSx,
        color: "#ffffff",
        backgroundColor: "#f9a825",
        borderColor: "#f9a825",
        boxShadow: "0 4px 18px rgba(249,168,37,0.35)",
        "& .MuiTypography-root, & .MuiButton-startIcon, & svg": { color: "#ffffff" },
        "&:hover": {
            color: "#ffffff",
            backgroundColor: "#f59e0b",
            borderColor: "#f59e0b",
            boxShadow: "0 8px 24px rgba(245,158,11,0.3)",
        },
        "&:focus, &:focus-visible": {
            boxShadow: "0 0 0 3px rgba(249,168,37,0.24)",
        },
    };
    const paymentExportBtnSx = {
        textTransform: "none",
        fontWeight: 700,
        fontSize: "0.86rem",
        borderRadius: "10px",
        py: 1.05,
        px: 1.6,
        color: "#14B8A6",
        borderColor: "rgba(20,184,166,0.55)",
        backgroundColor: theme.palette.mode === "dark" ? "rgba(20,184,166,0.08)" : "rgba(20,184,166,0.04)",
        whiteSpace: "nowrap",
        "& .MuiSvgIcon-root": {
            color: "#14B8A6",
        },
        "&:hover": {
            color: "#fff",
            borderColor: "#14B8A6",
            backgroundColor: "#14B8A6",
            boxShadow: "0 6px 22px rgba(20,184,166,0.28)",
            "& .MuiSvgIcon-root": {
                color: "#fff",
            },
        },
    };

    const { control, handleSubmit, setValue, getValues, reset, watch } = useForm<SearchPaymentRequest>();
    const [showCard, setShowCard] = useState(false);
    const {
      filterPanelRef,
      toggleFilterPanel,
      handleFilterPanelEntering,
      handleFilterPanelEntered,
      handleFilterPanelExited,
    } = useFilterPanelFocus(showCard, setShowCard);
    const [searchCriteria, setSearchCriteria] = useState<SearchPaymentRequest>({
        practiceIds: [],
        manufacturerIds: [],
        productIds: [], //CS-2103
        paymentStatus: [],
        invoiceNumber: "",
        currentPage: 1,
        itemsPerPage: ITEMS_PER_PAGE,
    });

    const { userInfo } = useAuthSlice();
    const { manufacturerInfoList, agencyInfoList } = useCommonReducer();
    const { productsByUserRole } = useProductListReducer(); //CS-2103
    const { searchPaymentList, practiceByUserRolePaymentSlice } = usePaymentSlice();
    const [voidConfirm, setVoidConfirm] = useState<{ message: string, show: boolean, row: any }>({ message: "", show: false, row: "" });
    //CS-1512 - Fetching the payent status types from codetable
    const { allCodeTablesValuesMap, allCodeTableValueFetchStatus } = useCodetablesSlice();
    const [paymentStatus, setPaymentStatus] = useState<CodeTable[]>([]);
    const canAccessVoidPayment = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessPaymentActions", PAYMENT_ACTIONS.VOID)(state));
    const canAccessDetailPayment = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessPaymentActions", PAYMENT_ACTIONS.DETAIL)(state));
    const canRecordPayments = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessPaymentActions", PAYMENT_ACTIONS.RECORD_PAYMENTS)(state));
    const [loadingComplete, setLoadingComplete] = useState<Boolean>(false);

    const [invoiceNumber, setInvoiceNumber] = useState<any>(null);
    const [activeButtonId, setActiveButtonId] = useState<string | null>(null); // CS-1555
    const { agencyExecutives } = usePracticeApproveSlice();
    const [isDateRangeChanged, setIsDateRangeChanged] = useState(false);
    const [isClearInvoiceDateRange, setIsClearInvoiceDateRange] = useState(false);
    const [isClearPaidDateRange, setIsClearPaidDateRange] = useState(false);
    const { NotificationInfoByRefEntity } = useCreateNotificationSlice();
    const [alertedPaymentIds, setAlertedPaymentIds] = useState<number[]>([]);
    const [notificationData, setNotificationData] = useState<any[]>([]);
    const [statusAnchorEl, setStatusAnchorEl] = useState<HTMLElement | null>(null);
    const canAccessNotifications = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessApplication", CAN_ACCESS_APPLICATION.NOTIFICATION_MANAGEMENT)(state));
    const accessibleNotifications = useSelector((state: RootState) => selectTokenValues("canAccessNotifications")(state));
    const [fetchNotificationsCompleted, setFetchNotificationsCompleted] = useState<Boolean>(false);
    const [isAlertOnly, setIsAlertOnly] = useState<boolean>(false);
    const [totalNotificationIds, setTotalNotificationIds] = useState([]);
    const [fetchNotificationCountCompleted, setFetchNotificationCountCompleted] = useState<Boolean>(false);
    const [anchorElMenu, setAnchorElMenu] = useState<null | HTMLElement>(null);

    const canExportPaymentList = useSelector((state: RootState) => selectIsValueFoundInToken("canAccessExportExcel", EXPORTABLE_ITEMS.PAYMENT)(state));
    const canAccessPurchaseAndBillFilter =
      userInfo?.userRole === USER_ROLES.ROLE_SUPERADMIN ||
      userInfo?.userRole === USER_ROLES.ROLE_ADMIN;

    useEffect(() => {
        const alertedPaymentIdsData = NotificationInfoByRefEntity?.map(notification => notification.entityId);
        if (alertedPaymentIdsData) {
            setAlertedPaymentIds(alertedPaymentIdsData);
        }

    }, [NotificationInfoByRefEntity])

    useEffect(() => {
        if (userInfo.notificationEnable && canAccessNotifications) {
            if (fetchNotificationCountCompleted && fetchNotificationsCompleted) {
                setLoadingComplete(true)
            }
        } else {
            setLoadingComplete(true)
        }
    }, [fetchNotificationCountCompleted, fetchNotificationsCompleted])

    const groupedNotifications = useMemo(() => {
        const map = new Map<number, any[]>();
        NotificationInfoByRefEntity?.forEach((notif) => {
            const paymentId = notif.entityId;
            if (!map.has(paymentId)) {
                map.set(paymentId, []);
            }
            map.get(paymentId)?.push(notif);
        });
        return map;
    }, [NotificationInfoByRefEntity]);

    const handleStatusClick = (event: React.MouseEvent<HTMLElement>, details: any) => {
        const notificationsForPayment = groupedNotifications.get(details.paymentId) || [];

        const popupData = notificationsForPayment.map((notif) => ({
            notificationId: notif.notificationId,
            description: notif.notificationMsg,
            invoiceNumber: details.invoiceNumber,
            dateTime: notif.auditTimestamp,
        }));

        setNotificationData(popupData);
        setStatusAnchorEl(event.currentTarget);
    };

    const handleAcknowledge = async (item: any) => {
        try {
            const notificationData = {
                notificationId: item.notificationId,
                comment: ""
            }
            const response = await dispatch(acknowledgeNotification(notificationData)).unwrap();
            if (response.message = "SUCCESS") {
                fetchNotificationsForEntities();
                handleFetchAlerts();
            }
            return response;
        } catch (err) {
            console.error("Failed to fetch wound codes:", err);
            return [];
        }
    }

    const fetchNotificationsForEntities = async () => {
        const paymentIdList = searchPaymentList?.content?.map(payment => Number(payment.paymentId));
        const data = {
            notificationTypes: canAccessNotifications && accessibleNotifications ? accessibleNotifications : [],
            refEntityIds: paymentIdList ? paymentIdList : [],
            refEntity: "PAYMENT"
        };

        if (canAccessNotifications && searchPaymentList) {
            const res = await dispatch(fetchNotificationsByRefEntities({ data: data, skipLoader: true }))
            if (res) {
                setFetchNotificationsCompleted(true)
            }
        }
    }

    const handleFetchAlerts = async () => {
        const data = {
            notificationTypes: accessibleNotifications ? accessibleNotifications : [],
            entity: "PAYMENT"
        }
        if (canAccessNotifications) {
            const response = await dispatch(fetchAlertEntityNumbers({ data: data, skipLoader: true })).unwrap();
            setTotalNotificationIds(response?.data?.totalNotificationIds)
            setFetchNotificationCountCompleted(true)
        }
    }
    const handleNotification = () => {
        if (!isAlertOnly) {
            if (location.state != null && location.state.paymentListSearchCriteria != null && location.state.paymentListSearchCriteria.paymentId != null) {
                location.state.paymentListSearchCriteria = {
                    ...location.state.paymentListSearchCriteria,
                }
            }
            setIsAlertOnly(true);
            const data2: SearchPaymentRequest = {
                ...getValues(),
                currentPage: 1,
                itemsPerPage: ITEMS_PER_PAGE,
                alertPayments: true,
            }
            setSearchCriteria(data2);
            navigate("/payment_list", { state: { paymentListSearchCriteria: data2 } });
        } else {
            if (location.state != null && location.state.paymentListSearchCriteria != null && location.state.paymentListSearchCriteria.paymentId != null) {
                location.state.paymentListSearchCriteria = {
                    ...location.state.paymentListSearchCriteria,
                }
            }
            setIsAlertOnly(false);
            const data2: SearchPaymentRequest = {
                ...getValues(),
                alertPayments: false,
                currentPage: 1,
                itemsPerPage: ITEMS_PER_PAGE,
            }
            setSearchCriteria(data2);
            navigate("/payment_list", { state: { paymentListSearchCriteria: data2 } });
        }
    }

    useEffect(() => {
        if (userInfo.notificationEnable && canAccessNotifications &&
            accessibleNotifications && accessibleNotifications.length > 0) {
            handleFetchAlerts();
        }
    }, [accessibleNotifications, searchPaymentList])

    useEffect(() => {
        if (userInfo.notificationEnable) {
            fetchNotificationsForEntities();
        }
    }, [searchPaymentList])

    const columns: Column[] = [
        { id: "invoiceNumber", label: "INV ID", minWidth: 100 },
        { id: "transactionId", label: "Transaction ID", minWidth: 100 },
        { id: "orderNumber", label: "Order ID", minWidth: 100 },
        { id: "practiceName", label: "Practice", minWidth: 100 },
        { id: "manufacturerName", label: "Manufacturer", minWidth: 100 },
        { id: "paymentMethod", label: "Pay Method", minWidth: 100 }, //CS-1512
        { id: "invoiceAmount", label: "INV Total", minWidth: 100 },//CS-1512
        { id: "paymentAmount", label: "Paid Amt", minWidth: 100 }, //CS-1576 : Label change Payment Amt to Paid Amount
        { id: "invoiceDate", label: "INV Date", minWidth: 100 },
        { id: "paymentDate", label: "Pay Date", minWidth: 100 },
        ...(userInfo?.userRole === USER_ROLES.ROLE_SUPERADMIN ? [
            { id: "agencyName", label: "Agency", minWidth: 100 },
            { id: "accountRepsNames", label: "Account Rep", minWidth: 100 },
        ] : []),
        { id: "paymentType", label: "Pay Type", minWidth: 100 },//CS-1576: Adding payment type column
        // { id: "paymentStatus", label: "Status", minWidth: 100 },// CS-1576: Moving status to last column
        { id: "customPaymentStatus", label: "Status", minWidth: 100 },// CS-1576: Moving status to last column
        {
            id: "action",
            label: "Action",
            minWidth: 100,
        },
    ];

    const paymentOptions = useMemo(() => {
        //CS-1563 START
        let statuses: CodeTable[] = [];
        if (allCodeTablesValuesMap) {
            statuses = getCodeTableValuesByTableName(allCodeTablesValuesMap, "PaymentMethods");
        }
        if (!statuses || statuses.length === 0) {
            dispatch(fetchAllCodeTablesValues());
        }
        let options: { label: string, value: any }[] = [];
        statuses?.map((option) => {
            // Use keyName as value to match backend data format
            options.push({ label: option.displayValue, value: option.keyName });
        });
        options.push({ label: "Record Payment", value: "Record Payment" });

        return options;
    }, [allCodeTablesValuesMap]);
    //CS-1563 END

    const agenciesList = useMemo(() => {
        let options: { label: string; value: any }[] = [];
        if (agencyInfoList) {
            if (agencyInfoList.length > 1) {
                const sortedAgencies: AgencyInfo[] = sortNames(agencyInfoList, 'agencyName');
                sortedAgencies.map((item) => {
                    options.push({
                        label: item.agencyName,
                        value: item.agencyId,
                    });
                });
            } else {
                agencyInfoList.map((item) => {
                    options.push({
                        label: item.agencyName,
                        value: item.agencyId,
                    });
                });
                if (
                    userInfo.entityName === USER_ROLE_ENTITY_NAMES.AGENCY ||
                    userInfo.entityName === USER_ROLE_ENTITY_NAMES.ACCOUNTEXECUTIVE
                ) {
                    setValue("agencyIds", [Number(agencyInfoList[0]?.agencyId)]);
                }
            }
        }
        return options;
    }, [agencyInfoList]);

    const accountRepOptions = useMemo(() => {
        let options: Option[] = [];

        if (userInfo.userRole != "ROLE_ACCOUNTEXECUTIVE") {
            if (agencyExecutives && agencyExecutives.length > 0) {

                const sortedRepList = sortNames(agencyExecutives, 'firstName');
                sortedRepList.forEach((rep: any) => {
                    options.push({ label: `${rep.firstName} ${rep.lastName}`, value: rep.userId });
                });
            }
        } else {
            options.push({ label: `${userInfo.firstName} ${userInfo.lastName}`, value: userInfo.userId.toString() });
        }

        return options;
    }, [agencyExecutives]);

    //CS-1576 - Fetching payment type from codetable
    const paymentTypeOptions = useMemo(() => {
        //CS-1563 START
        let statuses: CodeTable[] = [];
        if (allCodeTablesValuesMap) {
            statuses = getCodeTableValuesByTableName(allCodeTablesValuesMap, "PaymentType");
        }
        if (!statuses || statuses.length === 0) {
            dispatch(fetchAllCodeTablesValues());
        }
        let options: { label: string, value: any }[] = [];
        statuses?.map((option) => {
            // Use keyName as value to match backend data format
            options.push({ label: option.displayValue, value: option.keyName });
        });
        return options;
    }, [allCodeTablesValuesMap]);
    //Mount
    useEffect(() => {
        const defaultStatuses = setDefaultStatusFilters();
        reset({
            practiceIds: [],
            manufacturerIds: [],
            productIds: [], //CS-2103
            paymentStatus: defaultStatuses,
            invoiceNumber: "",
            transactionId:"",
            currentPage: 1,
            itemsPerPage: ITEMS_PER_PAGE
        });

        dispatch(showHideLoadingDialog(true))
        clearPrevSliceValues();
        loadInitialValues();
        //CS-1512 - Fetching the payment method types from codetable
        dispatch(fetchAllCodeTablesValues());
        //CS-1512 - Fetching the app config for payment method types
        // dispatch(fetchAppConfigList());
        //CS-2103 - Fetching products by user role (INCLUDING inactive) for the product filter
        dispatch(fetchProductsForProductsSearch(false));
        dispatch(fetchAgenciesList());
        dispatch(fetchActiveAgencyExecutives({ getAgencyAdmins: false, isInactive: true }));

    }, []);

    useEffect(() => {
        if (allCodeTableValueFetchStatus === "success" && allCodeTablesValuesMap) {
            const sortedStateList = [
                ...getCodeTableValuesByTableName(allCodeTablesValuesMap, "PaymentStatus"),
            ].sort((a, b) => a.displayValue.localeCompare(b.displayValue));
            setPaymentStatus(sortedStateList);
        }
    }, [allCodeTablesValuesMap, allCodeTableValueFetchStatus]);
    const clearPrevSliceValues = () => {
        dispatch(updateElementInCommonSlice({ elementName: "manufacturerInfoList", value: [] }));
        dispatch(updateElementInUserSlice({ elementName: "practiceByUserRoleUserSlice", value: [] }));
    };

    const loadInitialValues = async () => {
        const responseManufacture = await dispatch(fetchManufacturersList());
        const responsePractice = await dispatch(getPracticeListByUserRolePaymentSlice({ isActivePracticeOnly: true, skipLoader: true }));
        if (responseManufacture && responsePractice) {
            setLoadingComplete(true)
        }
    }

    //Unmount
    useEffect(() => () => {
        dispatch(resetPaymentList())
    }, []);

    useEffect(() => {
        //1. When login another user pagination is remain in the history and can redirect that page
        let criteria = getSearchCriteriaFromSessionStorage(CAN_ACCESS_APPLICATION.PAYMENT_MANAGEMENT + "SearchCriteria" + userInfo.userId);
        if ((location.state && location.state.paymentListSearchCriteria) || (location.state && location.state.withSearchHistory && criteria)) {
            if (location.state && location.state.withSearchHistory) {
                //Below navigate line call back to this useEffect - This for refreshing issue when navigate with state.withSearchHistory=true
                navigate("/payment_list", { state: { paymentListSearchCriteria: criteria } });
                return;
            };

            let searchCriteria: SearchPaymentRequest = {
                practiceIds: getValues('practiceIds') || [],
                manufacturerIds: getValues('manufacturerIds') || [],
                productIds: getValues('productIds') || [], //CS-2103
                paymentStatus: [],
                invoiceNumber: "",
                currentPage: 0,
                itemsPerPage: 0
            };
            if (location.state && location.state.paymentListSearchCriteria) {
                searchCriteria = location.state.paymentListSearchCriteria;
            } else {
                searchCriteria = criteria ? criteria : searchCriteria;
            };

            if (!isAdminUser && searchCriteria.paymentStatus) {
                searchCriteria.paymentStatus = searchCriteria.paymentStatus.filter(
                    status => status !== PAYMENT_STATUS.VOID
                );
            }

            setSearchCriteria(searchCriteria);
            setValuesToCriteriaFields(searchCriteria);
            searchPracticesList(searchCriteria);
        } else {
            loadInitialPracticeList(1);
        }
    }, [location.state]);

    const setValuesToCriteriaFields = (searchCriteria: SearchPaymentRequest) => {
        setValue("practiceIds", searchCriteria.practiceIds);
        setValue("manufacturerIds", searchCriteria.manufacturerIds);
        setValue("productIds", searchCriteria.productIds); //CS-2103
        setValue("invoiceNumber", searchCriteria.invoiceNumber);
        setValue("transactionId", searchCriteria.transactionId);
        setValue("paymentStatus", searchCriteria.paymentStatus);
        setValue("paymentType", searchCriteria.paymentType);
        setValue("orderNumber", searchCriteria.orderNumber);
        setValue("agencyIds", searchCriteria.agencyIds);
        setValue("accRepId", searchCriteria.accRepId);
        setValue("paymentAmountMin", searchCriteria.paymentAmountMin);
        setValue("paymentAmountMax", searchCriteria.paymentAmountMax);
        setValue("purchaseAndBillFilter", searchCriteria.purchaseAndBillFilter);
        if (searchCriteria.invoiceFromDate && searchCriteria.invoiceToDate) {
            const fromDate = searchCriteria.invoiceFromDate || "";
            const toDate = searchCriteria.invoiceToDate || "";
            setValue(
                "invoiceDateRange",
                fromDate && toDate ? `${fromDate} - ${toDate}` : ""
            );
        } else if (searchCriteria.invoiceFromDate) {
            const fromDate = searchCriteria.invoiceFromDate || "";
            setValue(
                "invoiceDateRange",
                fromDate ? `${fromDate}` : ""
            );
        }
        if (searchCriteria.paidFromDate && searchCriteria.paidToDate) {
            const fromDate = searchCriteria.paidFromDate || "";
            const toDate = searchCriteria.paidToDate || "";
            setValue(
                "paidDateRange",
                fromDate && toDate ? `${fromDate} - ${toDate}` : ""
            );
        } else if (searchCriteria.paidFromDate) {
            const fromDate = searchCriteria.paidFromDate || "";
            setValue(
                "paidDateRange",
                fromDate ? `${fromDate}` : ""
            );
        }
    }
    const loadInitialPracticeList = (pNumber: number = 1) => {
        const defaultStatuses = setDefaultStatusFilters();

        const data: SearchPaymentRequest = {
            practiceIds: getValues('practiceIds') || [],
            manufacturerIds: getValues('manufacturerIds') || [],
            productIds: getValues('productIds') || [], //CS-2103
            paymentStatus: defaultStatuses,
            invoiceNumber: "",
            transactionId: "",
            currentPage: pNumber,
            itemsPerPage: ITEMS_PER_PAGE,
        };
        setSearchCriteria(data);
        setValuesToCriteriaFields(data);
        searchPracticesList(data);
    };

    const searchPracticesList = (searchCriteria: SearchPaymentRequest) => {
        let dataToSearch = paymentListSort.normalize({ ...searchCriteria });
        if (!isAdminUser && dataToSearch.paymentStatus) {
            dataToSearch.paymentStatus = dataToSearch.paymentStatus.filter(
                status => status !== PAYMENT_STATUS.VOID
            );
        }
        console.log(dataToSearch)
        setSearchCriteriaToSessionStorage(CAN_ACCESS_APPLICATION.PAYMENT_MANAGEMENT + "SearchCriteria" + userInfo.userId, dataToSearch);
        if (userInfo.userRole !== USER_ROLES.ROLE_PRACTICE_USER_PRU) {
            dispatch(searchPayments(dataToSearch));
        }
    };

    const onSubmit = (data: SearchPaymentRequest) => {
        const data2: SearchPaymentRequest = {
            practiceIds: data.practiceIds,
            manufacturerIds: data.manufacturerIds,
            productIds: data.productIds, //CS-2103
            invoiceNumber: data.invoiceNumber,
            paymentStatus: data.paymentStatus,
            currentPage: 1,
            itemsPerPage: ITEMS_PER_PAGE,
            paymentMethod: data.paymentMethod, //CS-1512
            paymentType: data.paymentType, //CS-1576
            invoiceFromDate: data.invoiceFromDate,
            invoiceToDate: data.invoiceToDate,
            paidFromDate: data.paidFromDate,
            paidToDate: data.paidToDate,
            orderNumber: data.orderNumber,
            agencyIds: data.agencyIds,
            accRepId: data.accRepId,
            paymentAmountMin: data.paymentAmountMin,
            paymentAmountMax: data.paymentAmountMax,
            transactionId: data.transactionId,
            purchaseAndBillFilter: data.purchaseAndBillFilter,
            ...paymentListSort.pick(searchCriteria),
        }
        setSearchCriteria(data2);

        //Below navigate line call to useEffect[location.state] and search
        navigate("/payment_list", { state: { paymentListSearchCriteria: data2 } });
    };

    const handlePagination = (pageNumber: number) => {
        const data = {
            ...searchCriteria,
            currentPage: pageNumber + 1
        }
        setSearchCriteria(data);

        //Below navigate line call to useEffect[location.state] and search
        navigate("/payment_list", { state: { paymentListSearchCriteria: data } });
    };

    const handleTableSort = (columnId: string, order: "asc" | "desc") => {
        const data = paymentListSort.withSort(searchCriteria, columnId, order);
        if (!data) {
            return;
        }
        setSearchCriteria(data);
        navigate("/payment_list", { state: { paymentListSearchCriteria: data } });
    };

    const onVoidPayment = async (paymentId: number) => {
        const response = await dispatch(voidPayment(paymentId));
        if (response?.payload?.code === SUCCESS_CODE) {
            const alertObj: SingleAlertInfo = {
                message: "Payment void successful",
                alertType: "success",
            };
            dispatch(setSingleAlertObj(alertObj));
            navigate("/payment_list", { state: { withSearchHistory: true } });
        } else {
            const alertObj: SingleAlertInfo = {
                message: "Something went wrong",
                alertType: "error",
            };
            dispatch(setSingleAlertObj(alertObj));
        };
        setVoidConfirm({ message: "", show: false, row: "" });
    };

    const cancelVoidPayment = () => {
        setVoidConfirm({ message: "", show: false, row: "" });
    }

    // CS-1555 - Start
    useEffect(() => {
        const saved = sessionStorage.getItem("activeActionButtonId");
        if (saved) setActiveButtonId(saved);
    }, []);

    const handleActionButtonClick = (buttonId: string, originalClick: () => void) => {
        const currentPageKey = "paymentList";
        saveSelectionForPage(currentPageKey, buttonId);
        setActiveButtonId(buttonId);
        sessionStorage.setItem("activeActionButtonId", buttonId);
        originalClick();
    };

    const handleRowNavigateToDetails = (row: Row) => {
        if (!canAccessDetailPayment) return;
        const paymentId = String(row.paymentId);
        const invoiceNumber = row.rawInvoiceNumber;
        handleActionButtonClick(`paymentListActionButton-${paymentId}`, () => {
            navigate("/payment_detail", {
                state: {
                    paymentId: (row as any).paymentId,
                    invoiceNumber,
                    manufacturerName: (row as any).manufacturerName,
                    practiceName: (row as any).practiceName,
                    status: (row as any).paymentStatus,
                },
            });
        });
    };
    // CS-1555 - End

    const handleInvoiceListNavigate = (invoiceNumber: string) => {
        if (invoiceNumber !== null) {
            navigate("/invoice_list", { state: { mfgInvoiceNumber: invoiceNumber } });
        };
    };

    const isAdminUser = useMemo(() => {
        return userInfo?.userRole === USER_ROLES.ROLE_ADMIN ||
            userInfo?.userRole === USER_ROLES.ROLE_SUPERADMIN;
    }, [userInfo?.userRole]);

    const actionComponent = (row: PaymentInfo): JSX.Element => {
        return (
            <>
                {/* {
                canAccessVoidPayment &&
                <CustomIconButton
                    color="warning"
                    tooltipMessage="Void"
                    tooltipPlacement="top"
                    variant="outlined"
                    size="small"
                    style={{ display: `${hideElement(row.paymentStatus !== PAYMENT_STATUS.RECEIVED)}` }}
                    onClick={() => { setVoidConfirm({ message: "Are you sure you want to void this payment record?", show: true, row: row.paymentId })}}

                    >
                        <PlaylistRemoveOutlined fontSize="small" />
                    </CustomIconButton>
                } */}
                {
                    canAccessDetailPayment &&
                    <CustomIconButton
                        color="info"
                        tooltipMessage="Detail"
                        tooltipPlacement="top"
                        variant="outlined"
                        size="small"
                        // CS-1555 - Start
                        onClick={(e?: React.MouseEvent) => {
                            if (e) e.stopPropagation();
                            const invNo = (row as any).rawInvoiceNumber ?? row.invoiceNumber; // ensure primitive
                            handleActionButtonClick(`paymentListActionButton-${row.paymentId}`, () =>
                                navigate("/payment_detail", {
                                    state: {
                                        paymentId: row.paymentId,
                                        invoiceNumber: invNo,
                                        manufacturerName: row.manufacturerName,
                                        practiceName: row.practiceName,
                                        status: row.paymentStatus,
                                    },
                                })
                            );
                        }}
                    // CS-1555 - End
                    >
                        <ListAltOutlined fontSize="small" />
                    </CustomIconButton>
                }

            </>
        );
    };

    const paymentList = useMemo(() => {
        const rows: PaymentInfo[] = [];
        searchPaymentList && searchPaymentList?.content?.map(payment => {
            const row = {
                ...payment,
                paymentId: payment.paymentId,
                transactionId: payment.transactionId,
                rawInvoiceNumber: payment.invoiceNumber, // CS-1555
                invoiceNumber: payment.invoiceNumber !== null ? (
                    <Box display="flex" alignItems="center" gap={1}>
                        <Link
                            component="button"
                            underline="hover"
                            variant="body2"
                            // CS-1555 - Start
                            onClick={(e) => {
                                e.stopPropagation();
                                handleActionButtonClick(`paymentListActionButton-${payment.paymentId}`, () =>
                                    handleInvoiceListNavigate(String(payment.invoiceNumber))
                                );
                            }}
                            // CS-1555 - End
                            color={colors.info[300]}
                        >
                            {payment.invoiceNumber}
                        </Link>
                        {payment.isUpfrontOrder && (
                            <BoltOutlined
                                sx={{ fontSize: 20, color: "#00E5B0" }} titleAccess="Upfront Payment"
                            />
                        )}
                    </Box>
                ) : (
                    payment.invoiceNumber || ''
                ),
                invoiceAmount: priceFormatter(parseFloat(payment.invoiceAmount)),
                paymentAmount: priceFormatter(parseFloat(payment.paymentAmount)),
                paymentMethod: formatPaymentMethod(payment.paymentMethod), //CS-1512
                accountRepsNames: payment.accountRepNames.join(", ") || "N/A",
                customPaymentStatus: userInfo.notificationEnable ? (
                    <Box display="flex" alignItems="center" gap={1}>
                        {alertedPaymentIds.includes(payment.paymentId) && (
                            <Box
                                onClick={(e) => { e.stopPropagation(); handleStatusClick(e, row) }}
                                sx={{
                                    width: 10,
                                    height: 10,
                                    borderRadius: "50%",
                                    backgroundColor: rederDynamicStatusColor(payment?.paymentStatus),
                                    display: "inline-block",
                                    cursor: "pointer",
                                }}
                            />
                        )}
                        <Typography variant="body2" sx={{ display: "inline-block" }}>
                            {payment.paymentStatus}
                        </Typography>
                    </Box>
                ) : (
                    payment.paymentStatus
                )
            };
            setInvoiceNumber(payment.invoiceNumber);
            rows.push(row);
        });
        return rows;
    }, [searchPaymentList, alertedPaymentIds, userInfo.notificationEnable]);

    const practiceOptions = useMemo(() => {
        let options: Option[] = [];
        if (practiceByUserRolePaymentSlice && practiceByUserRolePaymentSlice.length > 0) {

            const sortedPracticeInfo: PracticeInfo[] = sortNames(practiceByUserRolePaymentSlice, 'practiceName');
            sortedPracticeInfo?.map(practice => {
                options.push({ value: practice.practiceId, label: practice.practiceName });
            });
        };
        return options;
    }, [practiceByUserRolePaymentSlice]);

    useEffect(() => {
        if (practiceByUserRolePaymentSlice && practiceByUserRolePaymentSlice.length === 1) {
            const singlePracticeId = Number(practiceByUserRolePaymentSlice[0]?.practiceId);
            setValue("practiceIds", [singlePracticeId]);
            setSearchCriteria(prevState => ({
                ...prevState,
                practiceIds: [singlePracticeId]
            }));
        }
    }, [practiceByUserRolePaymentSlice]);

    const manufacturesList = useMemo(() => {
        let options: { label: string; value: any }[] = [];
        if (manufacturerInfoList && manufacturerInfoList.length > 0) {
            manufacturerInfoList?.map((item) => {
                options.push({
                    label: item.manufacturerName,
                    value: item.manufacturerId,
                });
            });
        }
        if (options?.length > 0 && manufacturerInfoList.length === 1) {
            setValue("manufacturerIds", [Number(manufacturerInfoList[0]?.manufacturerId)]);
        }
        return options;
    }, [manufacturerInfoList, setValue]);

    //CS-2103 - Product filter options built from the products fetched by user role
    // Watch selected manufacturers to filter the product dropdown by manufacturer
    const selectedMfgIds = watch('manufacturerIds') || [];

    const productOptions = useMemo(() => {
        let options: { label: string; value: any }[] = [];
        if (productsByUserRole && productsByUserRole.length > 0) {
            // When manufacturer(s) are selected, only show products belonging to those manufacturers.
            const filteredByMfg = selectedMfgIds && selectedMfgIds.length > 0
                ? productsByUserRole.filter((product) => selectedMfgIds.includes(Number(product.manufacturerId)))
                : productsByUserRole;
            const sortedProductList: ProductInfo[] = sortNames(filteredByMfg, "productName");
            sortedProductList?.forEach((product) => {
                const isInactive = product.inactiveDate && dayjs(product.inactiveDate).isBefore(dayjs(), "day");
                options.push({ label: isInactive ? `${product.productName} (INACTIVE )` : product.productName, value: Number(product.productId) });
            });
        }
        return options;
    }, [productsByUserRole, selectedMfgIds]);

    // Remove any selected products that no longer belong to the selected manufacturer(s)
    useEffect(() => {
        const currentProductIds = getValues("productIds") || [];
        if (currentProductIds.length > 0) {
            const validProductIds = currentProductIds.filter((id: any) =>
                productOptions.some((option) => option.value === Number(id))
            );
            if (validProductIds.length !== currentProductIds.length) {
                setValue("productIds", validProductIds);
            }
        }
    }, [productOptions]);

    //CS-1512 - Payment status options from codetable
    // const paymentStatus = [
    //     { label: PAYMENT_STATUS.RECEIVED, value: PAYMENT_STATUS.RECEIVED },
    //     { label: PAYMENT_STATUS.VOID, value: PAYMENT_STATUS.VOID }
    // ];
    const paymentStatusOptions = useMemo(() => {
        let options: Option[] = [];
        if (paymentStatus && paymentStatus.length > 0) {
            paymentStatus?.map((item: any) => {
                if (item.keyName === PAYMENT_STATUS.VOID && !isAdminUser) {
                    return;
                }
                options.push({
                    label: item.keyName,
                    value: item.displayValue,
                });
            });
        }
        return options;
    }, [paymentStatus]);

    const handleInvoiceDateRangeChange = (fromDate: DateObject | null, toDate: DateObject | null) => {
        const fromDateString = fromDate ? fromDate.format("MM/DD/YYYY") : null;
        const toDateString = toDate ? toDate.format("MM/DD/YYYY") : null;

        setValue("invoiceFromDate", fromDateString ? fromDateString : "");
        setValue("invoiceToDate", toDateString ? toDateString : "");


        setIsDateRangeChanged(true);
    };

    const handlePaidDateRangeChange = (fromDate: DateObject | null, toDate: DateObject | null) => {
        const fromDateString = fromDate ? fromDate.format("MM/DD/YYYY") : null;
        const toDateString = toDate ? toDate.format("MM/DD/YYYY") : null;

        setValue("paidFromDate", fromDateString ? fromDateString : "");
        setValue("paidToDate", toDateString ? toDateString : "");


        setIsDateRangeChanged(true);
    };

    const handleMenuClose = () => {
        setAnchorElMenu(null);
    };
    const handleMenuClick = (event: React.MouseEvent<HTMLElement>) => {
        setAnchorElMenu(event.currentTarget);
    };

    const handleExport = () => {
        const searchCriteriaFromStorage = getSearchCriteriaFromSessionStorage(CAN_ACCESS_APPLICATION.PAYMENT_MANAGEMENT + "SearchCriteria" + userInfo.userId);

        if (searchCriteriaFromStorage) {
            let dataToSearch = {
                ...searchCriteria,
                currentPage: searchCriteriaFromStorage.currentPage,
                downloadState: true,
            };
            ExportToExcel(
                dataToSearch,
                columns,
                dispatch,
                EXPORTABLE_ITEMS.PAYMENT
            );

        };
    };

    useEffect(() => {
        if (loadingComplete && paymentList) {
            dispatch(showHideLoadingDialog(false))
        }
    }, [loadingComplete, paymentList])

    const totalRecords = searchPaymentList?.totalElements ?? 0;
    // Set default status filters (Processing and Received)
    const setDefaultStatusFilters = () => {
        const defaultStatuses = [PAYMENT_STATUS.PROCESSING, PAYMENT_STATUS.RECEIVED];
        setValue("paymentStatus", defaultStatuses);
        return defaultStatuses;
    };

    const purchaseAndBillOptions = [
        { label: "Yes", value: "Y" },
        { label: "No", value: "N" }
    ];

    return (
        <>
            <Box
                sx={{
                    minHeight: "100vh",
                    display: "flex",
                    flexDirection: "column",
                    px: { xs: 1, md: 3 },
                    py: 2,
                }}
            >
                <Box sx={{ position: "relative", zIndex: 20, overflow: "visible" }}>
                    <Collapse in={showCard} ref={filterPanelRef} onEntering={handleFilterPanelEntering} onEntered={handleFilterPanelEntered} onExited={handleFilterPanelExited}>
                        <Card sx={filterPanelSx}>
                            <form onSubmit={handleSubmit(onSubmit)}>
                                <Grid container spacing={2} alignItems="flex-end">
                                    {/* Row 1: Invoice ID | Transaction ID | Order ID | Practice Name */}
                                    <Grid item md={3} xs={12}>
                                        <CustomTextField controllerName="invoiceNumber" control={control} name="invoiceNumber" label="Invoice ID" placeholder="Enter invoice ID" size="small" />
                                    </Grid>
                                    <Grid item md={3} xs={12}>
                                        <CustomTextField
                                            controllerName="transactionId"
                                            control={control}
                                            name="transactionId"
                                            label="Transaction ID"
                                            placeholder="Enter transaction ID"
                                            size="small"
                                        />
                                    </Grid>
                                    <Grid item md={3} xs={12}>
                                        <CustomTextField
                                            controllerName="orderNumber"
                                            control={control}
                                            name="orderNumber"
                                            //CS-1141 - Start
                                            label="Order ID"
                                            placeholder="Enter order ID"
                                            size="small"
                                        //CS-1141- End
                                        />
                                    </Grid>
                                    <Grid item md={3} xs={12}>
                                        <CustomMultipleDropDown control={control} name="practiceIds" label="Practice Name" placeholderText="Select practice" options={practiceOptions} disabled={practiceOptions?.length === 1} size="small" />
                                    </Grid>
                                    {isAdminUser ? (
                                        <>
                                            {/* Row 2: Payment Status | Manufacturer | Product | Purchase & Bill */}
                                            <Grid item md={3} xs={12}>
                                                <CustomMultipleDropDown control={control} name="paymentStatus" label="Payment Status" placeholderText="Select status" options={paymentStatusOptions} size="small" />
                                            </Grid>
                                            <Grid item md={3} xs={12}>
                                                <CustomMultipleDropDown control={control} name="manufacturerIds" label="Manufacturer" placeholderText="Select manufacturer" options={manufacturesList} disabled={manufacturerInfoList?.length === 1} size="small" />
                                            </Grid>
                                            {/* CS-2103 : Adding product filter */}
                                            <Grid item md={3} xs={12}>
                                                <CustomMultipleDropDown control={control} name="productIds" label="Product" placeholderText="Select product" options={productOptions} size="small" />
                                            </Grid>
                                            {/* CS-2028 - Purchase & Bill filter: only visible to SuperAdmin and Admin */}
                                            {canAccessPurchaseAndBillFilter && (
                                                <Grid item md={3} xs={12}>
                                                    <CustomDropdownField control={control} name="purchaseAndBillFilter" label="Purchase & Bill" placeholderText="Select purchase & bill" options={purchaseAndBillOptions} sortOptions={false} size="small" />
                                                </Grid>
                                            )}
                                            {/* Row 3: Paid Date Range | Invoice Date Range | Pay Method | Pay Type */}
                                            <Grid item md={3} xs={12}>
                                                <CustomDateRange
                                                    label="Paid Date Range"
                                                    control={control}
                                                    controllerName="paidDateRange"
                                                    onChange={handlePaidDateRangeChange}
                                                    // dateRangeMonths={6}
                                                    onClear={isClearPaidDateRange}
                                                />
                                            </Grid>
                                            <Grid item md={3} xs={12}>
                                                <CustomDateRange
                                                    label="Invoice Date Range"
                                                    control={control}
                                                    controllerName="invoiceDateRange"
                                                    onChange={handleInvoiceDateRangeChange}
                                                    // dateRangeMonths={6}
                                                    onClear={isClearInvoiceDateRange}
                                                />
                                            </Grid>
                                            <Grid item md={3} xs={12}>
                                                <CustomMultipleDropDown control={control} name="paymentMethod" label="Pay Method" placeholderText="Select method" options={paymentOptions} size="small" />
                                            </Grid>
                                            <Grid item md={3} xs={12}>
                                                <CustomMultipleDropDown control={control} name="paymentType" label="Pay Type" placeholderText="Select pay type" options={paymentTypeOptions} size="small" />
                                            </Grid>
                                            {
                                                userInfo?.userRole === USER_ROLES.ROLE_SUPERADMIN &&
                                                <>
                                                    <Grid item md={3} xs={12}>
                                                        <CustomMultipleDropDown
                                                            control={control}
                                                            name="agencyIds"
                                                            label="Agency"
                                                            placeholderText="Select agency"
                                                            options={agenciesList}
                                                            size="small"
                                                        />
                                                    </Grid>
                                                    <Grid item md={3} xs={12}>
                                                        <CustomDropdownField name="accRepId" control={control} label="Account Rep" placeholderText="Select account rep" options={accountRepOptions} size="small" />
                                                    </Grid>
                                                </>
                                            }
                                            {/* Row 4: Paid Amount Range (Min/Max) | Search */}
                                            {/* CS-1576 : Adding payment type filter */}
                                            <Grid item md={3} xs={12}>
                                                <CustomAmountRange
                                                    label="Paid Amount Range"
                                                    control={control}
                                                    minControllerName="paymentAmountMin"
                                                    maxControllerName="paymentAmountMax"
                                                    minLabel="Min Paid Amt"
                                                    maxLabel="Max Paid Amt"
                                                    outlinedModal
                                                />
                                            </Grid>
                                        </>
                                    ) : (
                                        <>
                                            {/* Practice roles - Row 2: Paid Date Range | Invoice Date Range | Manufacturer | Product */}
                                            <Grid item md={3} xs={12}>
                                                <CustomDateRange
                                                    label="Paid Date Range"
                                                    control={control}
                                                    controllerName="paidDateRange"
                                                    onChange={handlePaidDateRangeChange}
                                                    onClear={isClearPaidDateRange}
                                                />
                                            </Grid>
                                            <Grid item md={3} xs={12}>
                                                <CustomDateRange
                                                    label="Invoice Date Range"
                                                    control={control}
                                                    controllerName="invoiceDateRange"
                                                    onChange={handleInvoiceDateRangeChange}
                                                    onClear={isClearInvoiceDateRange}
                                                />
                                            </Grid>
                                            <Grid item md={3} xs={12}>
                                                <CustomMultipleDropDown control={control} name="manufacturerIds" label="Manufacturer" placeholderText="Select manufacturer" options={manufacturesList} disabled={manufacturerInfoList?.length === 1} size="small" />
                                            </Grid>
                                            <Grid item md={3} xs={12}>
                                                <CustomMultipleDropDown control={control} name="productIds" label="Product" placeholderText="Select product" options={productOptions} size="small" />
                                            </Grid>
                                            {/* Practice roles - Row 3: Payment Status | Pay Method | Pay Type | Paid Amount Range */}
                                            <Grid item md={3} xs={12}>
                                                <CustomMultipleDropDown control={control} name="paymentStatus" label="Payment Status" placeholderText="Select status" options={paymentStatusOptions} size="small" />
                                            </Grid>
                                            <Grid item md={3} xs={12}>
                                                <CustomMultipleDropDown control={control} name="paymentMethod" label="Pay Method" placeholderText="Select method" options={paymentOptions} size="small" />
                                            </Grid>
                                            <Grid item md={3} xs={12}>
                                                <CustomMultipleDropDown control={control} name="paymentType" label="Pay Type" placeholderText="Select pay type" options={paymentTypeOptions} size="small" />
                                            </Grid>
                                            <Grid item md={3} xs={12}>
                                                <CustomAmountRange
                                                    label="Paid Amount Range"
                                                    control={control}
                                                    minControllerName="paymentAmountMin"
                                                    maxControllerName="paymentAmountMax"
                                                    minLabel="Min Paid Amt"
                                                    maxLabel="Max Paid Amt"
                                                    outlinedModal
                                                />
                                            </Grid>
                                        {/* CS-2029 - Spacer pushes the shared Search button to the right-most column for practice roles */}
                                        <Grid item md={9} xs={12} sx={{ display: { xs: "none", md: "block" } }} />
                                        </>
                                    )}
                                    <Grid item md={3} xs={12}>
                                        <Button fullWidth size="large" startIcon={<SearchOutlined />} sx={{ ...primaryActionBtnSx, height: "42px", py: 0 }} type="submit" removeUpperCase>
                                            Search
                                        </Button>
                                    </Grid>
                                </Grid>
                            </form>
                        </Card>
                    </Collapse>
                </Box>
                <Box mt={2} sx={{ position: "relative", zIndex: 1 }}>
                    <Card sx={{ ...cardSx, p: { xs: "14px !important", md: "18px !important" }, position: "relative", zIndex: 1 }}>
                        <Grid container justifyContent="space-between" alignItems="center" spacing={1.2}>
                            <Grid item xs={12} md>
                                <Typography variant='h3' fontWeight={800} color="text.primary">Payment List</Typography>
                            </Grid>
                            <Grid item xs={12} md="auto">
                                {canAccessNotifications && userInfo.notificationEnable
                                    && totalNotificationIds && totalNotificationIds.length > 0 &&
                                    <CustomIconButton
                                        color="warning"
                                        variant="contained"
                                        tooltipMessage="Payment Notifications"
                                        size="small"
                                        notifyCount={totalNotificationIds?.length}
                                        onClick={handleNotification}
                                    >
                                        {isAlertOnly ?
                                            <Notifications />
                                            :
                                            <NotificationsOutlined />
                                        }
                                    </CustomIconButton>
                                }
                            </Grid>
                            <Grid item xs={12} md="auto">
                                <Button variant="outlined" color="info" onClick={toggleFilterPanel} startIcon={<SearchOutlined />} fullWidth sx={outlineBtnSx} removeUpperCase>
                                    {showCard ? "Hide Filters" : "Show Filters"}
                                </Button>
                            </Grid>
                            {canRecordPayments &&
                                <Grid item xs={12} md="auto">
                                    <Button color="warning" onClick={() => navigate("/record_multiple_payment")} sx={paymentRecordBtnSx} removeUpperCase>
                                        Record Payments
                                    </Button>
                                </Grid>
                            }
                            {canExportPaymentList && (
                                <Grid item xs={12} md="auto">
                                    {!isMobile && (
                                        <Button
                                            id="customized-button"
                                            aria-controls={Boolean(anchorElMenu) ? "customized-menu" : undefined}
                                            aria-haspopup="true"
                                            aria-expanded={Boolean(anchorElMenu) ? "true" : undefined}
                                            variant="outlined"
                                            disableElevation
                                            onClick={handleMenuClick}
                                            startIcon={<ExitToApp />}
                                            sx={paymentExportBtnSx}
                                            removeUpperCase
                                            endIcon={
                                                <Box
                                                    component="span"
                                                    sx={{
                                                        display: "flex",
                                                        transition: "transform 0.3s ease",
                                                        transform: anchorElMenu ? "rotate(180deg)" : "rotate(0deg)",
                                                        padding: "2px",
                                                    }}
                                                >
                                                    <KeyboardArrowDown />
                                                </Box>
                                            }
                                        >
                                            Export
                                        </Button>
                                    )}
                                </Grid>
                            )}

                            <Grid item xs={12} md="auto">
                                <Box>
                                    {canExportPaymentList && isMobile && (
                                        <Box position="absolute" mt={1}>
                                            <Button
                                                color="success"
                                                variant="text"
                                                onClick={(event) => handleMenuClick(event)}
                                                startIcon={<DownloadOutlined fontSize="small" />}
                                                sx={paymentExportBtnSx}
                                                removeUpperCase
                                            >
                                                Export
                                            </Button>
                                        </Box>
                                    )}

                                    <StyledMenu
                                        id="customized-menu"
                                        MenuListProps={{ "aria-labelledby": "customized-button" }}
                                        anchorEl={anchorElMenu}
                                        open={Boolean(anchorElMenu)}
                                        onClose={handleMenuClose}
                                        slotProps={{
                                            paper: {
                                                sx: exportMenuPaperSx,
                                            },
                                        }}
                                    >

                                        <Box sx={{ px: 1, mb: 1 }}>
                                            <Button
                                                fullWidth
                                                variant="outlined"
                                                startIcon={<CloudDownload />}
                                                onClick={() => handleExport()}
                                                disabled={totalRecords > 1000}
                                                sx={exportMenuItemBtnSx}
                                                removeUpperCase
                                            >
                                                Export Search List
                                            </Button>
                                        </Box>

                                        {/* <Box sx={{ px: 1, mb: 1 }}>
                                            <Button
                                                fullWidth
                                                variant="contained"
                                                color="success"
                                                startIcon={<CloudDownload />}
                                                disabled={totalRecords > 1000}
                                                sx={{
                                                    py: 1,
                                                    justifyContent: "flex-start",
                                                    textTransform: "none",
                                                    fontSize: "1rem",
                                                }}
                                            >
                                                Export Details List
                                            </Button>
                                        </Box> */}

                                        {totalRecords > 1000 && (
                                            <Box
                                                sx={{
                                                    mx: 1,
                                                    p: 1.5,
                                                    mt: 1,
                                                    backgroundColor: "warning.light",
                                                    borderRadius: 1,
                                                    color: "warning.contrastText",
                                                }}
                                            >
                                                <Typography variant="body2">
                                                    Export is available only when the list contains 1,000 records or fewer.
                                                    Maximum export size: 1000 records.
                                                </Typography>
                                            </Box>
                                        )}
                                    </StyledMenu>
                                </Box>
                            </Grid>

                        </Grid>
                        <Table
                            columns={columns}
                            rows={loadingComplete ? paymentList || [] : []}
                            actionComponent={(row: PaymentInfo) => actionComponent(row)}
                            emptyText="No Payment(s) Found"
                            pageNumber={handlePagination}
                            uniqueValue="paymentId"
                            totalPages={loadingComplete ? searchPaymentList?.totalPages : 0}
                            totalElementText={"Records: " + ((loadingComplete && searchPaymentList?.totalElements) ? searchPaymentList?.totalElements : "0")}
                            currentPageNumber={searchCriteria.currentPage - 1}
                            showMenu={true}
                            sortableColumns={paymentListSort.sortableColumns}
                            serverSideSorting
                            onSortChange={handleTableSort}
                            controlledSortColumn={paymentListSort.controlledColumn(searchCriteria.sortBy)}
                            controlledSortOrder={searchCriteria.sortOrder ?? null}
                            currentPageKey={"paymentList"}
                            // CS-1555 - Start
                            activeButtonId={activeButtonId}
                            onRowClick={handleRowNavigateToDetails}
                            clickableCards={true}
                            sx={tableSx}
                        // CS-1555 - End
                        />
                    </Card>
                </Box>
            </Box>
            {voidConfirm.show &&
                <OptionsPopup
                    open={voidConfirm.show}
                    onClose={() => setVoidConfirm({ message: "", show: false, row: "" })}
                    variant="confirm"
                    message={<>{voidConfirm.message}</>}
                    buttons={[{ name: "Confirm", color: 'primary', onClick: () => onVoidPayment(voidConfirm.row) }, { name: "Cancel", color: 'secondary', onClick: cancelVoidPayment }]}
                />
            }
            {userInfo.notificationEnable &&
                <StatusInfoPopup
                    anchorEl={statusAnchorEl}
                    onAcknowledge={handleAcknowledge}
                    onClose={() => {
                        setStatusAnchorEl(null)
                    }
                    }
                    rows={notificationData}
                />
            }
        </>
    );

}

export default PaymentList;